import {ResultType} from '@remix-run/router/dist/utils';
import axios from 'axios';
import React from 'react';
import {BASE_URL} from '../config';
import {fetch} from '../../src/apiFunction';

export const createCase = async (data) => {
  const payload = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const url = BASE_URL + '/cases/create';
  const type = 'post';
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const getAllCases = async (query) => {
  var requestQuery = '';

  if (query) {
    var requestQuery = Object.keys(query)
      .filter((v) => {
        return query[v] !== null;
      })
      .filter((v) => query[v] !== 0)
      .filter((v) => query[v] !== '')
      .map((v) => {
        return `${v}=${query[v]}`;
      })
      .join('&');
  }

  const finalRequestQuery = requestQuery.replace(/\s/g, '');
  const url = BASE_URL + '/cases/get-all?' + finalRequestQuery;
  const token = localStorage.getItem('token');
  const type = 'get';
  const resp = await fetch(url, type, null, token);
  return resp;
};

export const UpdateCase = async (data, caseId) => {
  const payload = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const url = BASE_URL + '/cases/update-all/' + caseId;
  const type = 'post';
  const resp = await fetch(url, type, payload, token);
  return resp;
};

export const getAllTodayCase = async () => {
  const token = localStorage.getItem('token');
  const url = BASE_URL + '/cases/all-cases';
  const type = 'get';
  const resp = await fetch(url, type, null, token);
  return resp;
};

export const UpdateCaseFollowUp = async (data, caseId) => {
  const payload = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const url = BASE_URL + '/cases/update/' + caseId;
  const type = 'post';
  const resp = await fetch(url, type, payload, token);
  return resp;
};

export const getCaseById = async (caseId) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/cases/get-case/' + caseId;
  const resp = fetch(url, type, null, token);
  return resp;
};
